import { TablesGraphQLResourceQuery } from '~src/catalog/fetchers/TablesGraphQLResourceQuery';
import { TablesWithCrass } from '~src/catalog/resources/TablesWithCrass';
import { Messages } from '~src/codegen/Localize';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ExplorableItemDefinition, MixedContentItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { TableContentType, TableWithCRASSSearchSubspaceType } from '~src/spacesPlatform/models/ContentTypes';

import { getGenericDefaultFilters } from '../../../spacesPlatform/contentDefinitions/getDefaultFilters';
import { TableCard } from '../Tables/TableCard';

const tableInProjectsEnabled: boolean =  FeatureFlags.tablesInProjectsEnabled
                                      && FeatureFlags.tablesInProjectsUIEnabled;
export const TableDefinition: ExplorableItemDefinition & SpaceDefinition<'table'> = {
  itemType: 'table',
  contentType: 'table',
  pluralName: Messages.tables,
  singularName: Messages.table,
  emptyStateMessage: Messages.tablesEmptyMessage,
  contentFilterKeys: TableContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent:  TableCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => new TablesGraphQLResourceQuery(),
  getContentInfo: () => {
  },
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.catalogTableUrl(contentId),
  headerIconPath: () => '',
  supportedDisplayModes: ['list'],
};

export const TableWithCrassDefinition: MixedContentItemDefinition & SpaceDefinition<'tableWithCrass'> = {
  itemType: 'tableWithCrass',
  contentType: 'tableWithCrass',
  pluralName: Messages.tables,
  singularName: Messages.table,
  emptyStateMessage: Messages.tablesEmptyMessage,
  siteFilterByTypeDropdownName: () => 'tables',
  contentFilterKeys: TableWithCRASSSearchSubspaceType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: TableCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => {
    return TablesWithCrass.all().withExtraParams(TableContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.catalogTableUrl(contentId),
  headerIconPath: () => '',
  supportedDisplayModes: tableInProjectsEnabled ? ['list','thumbnail'] : ['list']
};
